<template>
  <div
    class="details-card-wrapper"
    :data-title="title"
    :data-max-length="maxLength || ''"
  >
    <b-card header-tag="header">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0 d-inline-block align-middle">
            <b>{{ header }}</b>
          </p>
          <slot name="actions" />
        </div>
      </template>
      <!-- Il contenuto di default è la griglia etichetta/valore delle `rows`;
           DetailsCard lo sostituisce con la propria griglia modificabile. -->
      <slot>
        <div class="details-card custom-grid-wrapper">
          <template v-for="(row, index) in rows">
            <div :class="cellClass(index, 'label')" :key="`label_${index}`">
              <strong>{{ row.label }}</strong>
            </div>
            <div :class="cellClass(index, 'value')" :key="`value_${index}`">
              <span v-if="row.html !== undefined" v-html="row.html"></span>
              <template v-else>{{ row.value }}</template>
            </div>
          </template>
          <p class="empty-details" v-if="emptyText && !rows.length">
            <i>{{ emptyText }}</i>
          </p>
        </div>
      </slot>
    </b-card>
  </div>
</template>

<script>
// Card di dettaglio in sola lettura: intestazione e coppie etichetta/valore a
// righe alternate. Una riga è { label, value } oppure { label, html }.
export default {
  props: {
    header: String,
    title: String,
    rows: {
      type: Array,
      default: () => [],
    },
    // Larghezza della colonna degli importi (vedi utils/strings priceColumnWidth).
    maxLength: [Number, String],
    emptyText: String,
  },
  methods: {
    cellClass(index, kind) {
      return {
        even: index % 2 === 0,
        odd: index % 2 !== 0,
        [`grid-item-${kind}`]: true,
      };
    },
  },
};
</script>
